import React, { useState } from 'react';
import { Modal, Upload, message, Alert, Typography } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;
const { Text } = Typography;

const UploadShippingCsvModal = ({ visible, onCancel, onUpload, loading }) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning('Vui lòng chọn file CSV');
      return;
    }

    const formData = new FormData();
    formData.append('file', fileList[0]);

    setUploading(true);
    try {
      await onUpload(formData);
      setFileList([]);
      onCancel();
    } catch (error) {
      console.error('Upload error:', error);
    } finally {
      setUploading(false);
    }
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    fileList: fileList,
    accept: '.csv',
    beforeUpload: (file) => {
      const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
      if (!isCSV) {
        message.error('Chỉ chấp nhận file CSV!');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error('File phải nhỏ hơn 10MB!');
        return false;
      }
      setFileList([file]);
      return false; // Prevent auto upload
    },
    onRemove: () => {
      setFileList([]);
    },
  };

  return (
    <Modal
      title="Upload CSV Shipping Report"
      open={visible}
      onCancel={() => {
        setFileList([]);
        onCancel();
      }}
      onOk={handleUpload}
      confirmLoading={uploading || loading}
      okText="Upload"
      cancelText="Hủy"
      width={600}
    >
      <Alert
        message="Thông tin"
        description={
          <div>
            <Text>File CSV cần có các cột sau:</Text>
            <ul style={{ marginTop: 8, marginBottom: 0 }}>
              <li><strong>Name</strong>: Order name (ví dụ: #GSS2922)</li>
              <li><strong>Shipping Name</strong>: Tên người nhận</li>
              <li><strong>Shipping Address1</strong>: Địa chỉ dòng 1</li>
              <li><strong>Shipping Address2</strong>: Địa chỉ dòng 2</li>
              <li><strong>Shipping City</strong>: Thành phố</li>
              <li><strong>Shipping Zip</strong>: Mã bưu điện</li>
              <li><strong>Shipping Province</strong>: Tỉnh/Bang</li>
              <li><strong>Shipping Country</strong>: Quốc gia</li>
              <li><strong>Shipping Phone</strong>: Số điện thoại</li>
            </ul>
            <Text type="secondary" style={{ fontSize: 12, marginTop: 8, display: 'block' }}>
              * Chỉ cập nhật thông tin shipping, không thay đổi các trường khác
            </Text>
          </div>
        }
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      
      <Dragger {...uploadProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click hoặc kéo file CSV vào đây</p>
        <p className="ant-upload-hint">
          Hỗ trợ file CSV từ Shopify Order Export
        </p>
      </Dragger>
    </Modal>
  );
};

export default UploadShippingCsvModal;
